import React, { useEffect, useState } from 'react'
import { getBrandsWithPage } from "../../services/serviceBrand";
import { Card, Table, Button } from "antd";
import BrandCreate from "./BrandCreate";
import BrandActions from "./BrandActions";

const Brand = () => {
    const [sortedList, setSortedList] = useState([])
    const [newModal, setNewModal] = useState(false)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getBrands(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getBrands = (page, pageSize) => {
        getBrandsWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getBrands(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    brandName: item.name,
                    brandCode: item.code,
                    brandDescription: item.description
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    };

    const columns = [
        {
            title: 'Adı',
            dataIndex: 'brandName',
            key: 'brandName'
        },
        {
            title: 'Kodu',
            dataIndex: 'brandCode',
            key: 'brandCode'
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => record.brandName.toLowerCase() === 'armaled' ? null : <BrandActions record={record} updater={handlers.updater} />
        }
    ]

    return (
        <React.Fragment>
            <Card title={'Marka Listesi'}
                extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni Ekle </Button>}>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ?
                <BrandCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}

        </React.Fragment>
    )

}
export default Brand